'use client';

import { SecurityPasskeys as Section } from '../../components/UserProfile/SecuritySections';
import { createSection } from '../createSection';

export const UserProfilePasskeysSection = createSection('UserProfilePasskeysSection', Section);
